import { IRecommendedPackageService } from '../../../../types/reducers/recommendedPackages';
import { EServiceType } from '../../../../types/reducers/publishTerms';
import { defaultTo } from 'ramda';

const SERVICE_TYPES_NAMES = {
  [EServiceType.Top3]: 'Топ',
  [EServiceType.Premium]: 'Премиум',
  [EServiceType.Paid]: 'Публикации',
  [EServiceType.Standard]: 'Стандарт',
  [EServiceType.Free]: 'Публикации',
  [EServiceType.Auction]: 'Баллы',
  [EServiceType.Calltracking]: 'Защита номера',
};

export const getServiceName = (serviceName: IRecommendedPackageService['serviceType']): string => {
  return defaultTo('', SERVICE_TYPES_NAMES[serviceName]);
};
